import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import NumberFormat from "react-number-format";

import { TooltipP } from "../../components/tooltip";

import { Promotion } from "./infocar";

import { Tooltip } from "../../common/svg";

//-- *** PriceSummary Props
//-- car: mode view cardetail
//-- trip: mode view tripdetail
//-- promo: promoCode
//-- priceMode: priceMode === 2 || priceMode === 3 ? priceWithFee : price
//-- Note: promo at cardetail (car === true) must be with openPromoBox, removePromoCode function
//-- isOwner: isOwner (tripdetail)

const PriceSpecialModal = ({ show, onHide, priceMode }) => (
	<Modal show={show} onHide={onHide} dialogClassName="modal-m modal-text modal-fix">
		<Modal.Header closeButton={true} closeLabel={""}>
			<h5>Đơn giá thuê</h5>
		</Modal.Header>
		<Modal.Body>
			<div className="modal-text-body">
				<div className="block-content">
					<p>• Giá thuê xe được tính tròn theo ngày, thời gian thuê xe ít hơn 24 tiếng sẽ được tính tròn 1 ngày.</p>
				</div>
				<div className="block-content">
					<p>
						• Giá thuê không bao gồm tiền xăng / tiền sạc pin. Khi kết thúc chuyến đi bạn vui lòng đổ xăng, sạc pin về
						lại mức ban đầu như khi nhận xe, hoặc thanh toán lại chi phí xăng xe sạc pin cho chủ xe.
					</p>
				</div>
				{priceMode === 2 && (
					<div className="block-content">
						<p>
							• Giá thuê xe đã bao gồm phí dịch vụ của Mioto. Phí dịch vụ giúp chúng tôi duy trì ứng dụng & triển khai
							các hoạt động chăm sóc khách hàng một cách chu đáo, nhằm đảm bảo bạn có được chuyến đi an toàn & trải
							nghiệm tốt nhất cùng Mioto, bao gồm:
						</p>
						<p>-- Dịch vụ tổng đài, chăm sóc & hỗ trợ khách hàng đặt xe.</p>
						<p>-- Tìm xe thay thế / hoàn tiền / đền tiền nếu chuyến bị hủy bởi chủ xe.</p>
						<p>-- Tìm xe thay thế / hoàn tiền nếu bạn thay đổi lịch trình.</p>
						<p>-- Hỗ trợ dàn xếp tranh chấp phát sinh với chủ xe (nếu có).</p>
						<p>-- Hỗ trợ làm việc với nhà bảo hiểm, garage đối tác khi xảy ra sự cố (nếu có).</p>
						<p>-- Và tất cả những vấn đề phát sinh khác trong quá trình thuê xe nếu bạn cần sự hỗ trợ từ chúng tôi.</p>
					</div>
				)}
			</div>
		</Modal.Body>
	</Modal>
);

const TripFeeModal = ({ show, onHide, trip, isOwner, isSD }) => (
	<Modal show={show} onHide={onHide} dialogClassName="modal-m modal-text modal-fix">
		<Modal.Header closeButton={true} closeLabel={""}>
			<h5>Phí dịch vụ</h5>
		</Modal.Header>
		<Modal.Body>
			<div className="modal-text-body">
				{trip && isOwner && isSD ? (
					<div className="block-content">
						<p>
							Phí dịch vụ khách thuê giúp Mioto duy trì việc vận hành hệ thống và triển khai các hoạt động CSKH một cách
							chu đáo, nhằm đảm bảo khách thuê có được chuyến đi an toàn & trải nghiệm tốt nhất.
						</p>
					</div>
				) : (
					<div className="block-content">
						<p>
							Phí dịch vụ giúp chúng tôi duy trì ứng dụng & triển khai các hoạt động chăm sóc khách hàng một cách chu
							đáo, nhằm đảm bảo bạn có được chuyến đi an toàn & trải nghiệm tốt nhất cùng Mioto, bao gồm:
						</p>
						<p>-- Dịch vụ tổng đài, chăm sóc & hỗ trợ khách hàng đặt xe.</p>
						<p>-- Tìm xe thay thế / hoàn tiền / đền tiền nếu chuyến bị hủy bởi chủ xe.</p>
						<p>-- Tìm xe thay thế / hoàn tiền nếu bạn thay đổi lịch trình.</p>
						<p>-- Hỗ trợ dàn xếp tranh chấp phát sinh với chủ xe (nếu có).</p>
						<p>-- Hỗ trợ làm việc với nhà bảo hiểm, garage đối tác khi xảy ra sự cố (nếu có).</p>
						<p>-- Và tất cả những vấn đề phát sinh khác trong quá trình thuê xe nếu bạn cần sự hỗ trợ từ chúng tôi.</p>
					</div>
				)}
			</div>
		</Modal.Body>
	</Modal>
);

const PriceSpecialViewOwnerModal = ({ show, onHide }) => (
	<Modal show={show} onHide={onHide} dialogClassName="modal-m modal-text modal-fix">
		<Modal.Header closeButton={true} closeLabel={""}>
			<h5>Đơn giá thuê</h5>
		</Modal.Header>
		<Modal.Body>
			<div className="modal-text-body">
				<div className="block-content">
					<p>Là giá thuê xe theo ngày mà chủ xe thiết lập trên ứng dụng.</p>
					<p>
						• Trường hợp khách hàng thuê xe nhiều ngày, đơn giá thuê được xác định bằng cách tính bình quân giá thuê
						giữa các ngày.
					</p>
				</div>
			</div>
		</Modal.Body>
	</Modal>
);

const TripFeeViewOwnerModal = ({ show, onHide }) => (
	<Modal show={show} onHide={onHide} dialogClassName="modal-m modal-text modal-fix">
		<Modal.Header closeButton={true} closeLabel={""}>
			<h5>Phí dịch vụ - Chủ xe</h5>
		</Modal.Header>
		<Modal.Body>
			<div className="modal-text-body">
				<div className="block-content">
					<p>
						Phí dịch vụ chủ xe (đã gồm VAT) được tính 15% trên tổng
						<b> Doanh thu cho thuê xe & Doanh thu giao nhận xe.</b>
					</p>
					<p>
						Phí dịch vụ chủ xe giúp Mioto triển khai các hoạt động chăm sóc đối tác chủ xe & các hoạt động tiếp thị,
						khuyến mãi nhằm tăng số lượng đơn hàng của các chủ xe trên ứng dụng Mioto, bao gồm:
					</p>
					<p>• Dịch vụ quảng cáo, tiếp thị trên các nền tảng số & kênh truyền thống.</p>
					<p>• Các hoạt động khuyến mãi dành cho khách hàng thuê xe.</p>
					<p>
						• Dịch vụ tổng đài, chăm sóc và hỗ trợ đối tác chủ xe trong các vấn đề liên quan đến thông tin xe cho thuê &
						sử dụng ứng dụng.
					</p>
					<p>• Xử lí cộng tiền/hoàn tiền vào ví chủ xe nếu chuyến đi bị hủy bởi khách thuê.</p>
					<p>• Hỗ trợ dàn xếp tranh chấp với khách thuê (nếu có).</p>
					<p>• Hỗ trợ làm việc với nhà bảo hiểm, garage đối tác khi xảy ra sự cố (nếu có).</p>
					<p>
						• Và tất cả những vấn đề phát sinh khác trong quá trình cho thuê xe nếu đối tác chủ xe cần sự hỗ trợ từ
						Mioto.
					</p>
				</div>
			</div>
		</Modal.Body>
	</Modal>
);

const InsSDModal = ({ show, onHide, trip, isOwner }) => (
	<Modal show={show} onHide={onHide} dialogClassName="modal-m modal-text modal-fix">
		<Modal.Header closeButton={true} closeLabel={""}>
			<h5>Bảo hiểm thuê xe tự lái</h5>
		</Modal.Header>
		<Modal.Body>
			{trip && isOwner ? (
				<div className="modal-text-body">
					<div className="block-content">
						<p>
							Chuyến đi trên Mioto đã được mua <b>Bảo hiểm thuê xe tự lái !</b>
						</p>
					</div>
					<div className="block-content">
						<p>
							• Hầu hết rủi ro phát sinh trong quá trình thuê xe tự lái, đặc biệt với những tổn thất lớn trong các sự vụ
							đâm đụng, thủy kích, cháy nổ (có thể lên đến hàng trăm triệu đồng, vượt khả năng chi trả của khách hàng)
							sẽ <u className="fontWeight-8 text-danger">không thuộc phạm vi</u> của <b>Bảo hiểm thân vỏ xe theo năm</b>{" "}
							(còn gọi là Bảo hiểm 2 chiều).
						</p>
					</div>
					<div className="block-content">
						<p>
							• Vì vậy, Gói bảo hiểm thuê xe tự lái từ MIC & VNI (được thiết kế dành riêng cho các giao dịch thuê xe
							trên Mioto) sẽ giúp bảo vệ khách thuê khỏi các tổn thất tài chính lớn khi gặp sự cố trong quá trình thuê
							xe cũng như đảm bảo quyền lợi của chủ xe trong trường hợp khách hàng không đủ khả năng tài chính chi trả.
						</p>
					</div>
					<div className="block-content text-success">
						<p className="fontWeight-8">Lưu ý:</p>
						<p>
							Các sự vụ tổn thất nhỏ dưới hoặc quanh mốc 2 triệu đồng (va quẹt nhẹ, trầy xước xe), Mioto khuyến nghị chủ
							xe có thể tự thỏa thuận với khách hàng để xử lí vì mức khấu trừ của Gói bảo hiểm thuê xe tự lái trên Mioto
							đang là 2 triệu đồng (nghĩa là nhà bảo hiểm chỉ bảo vệ cho các thiệt hại từ 2 triệu đồng trở lên theo như
							tiêu chí ban đầu của gói bảo hiểm).
						</p>
					</div>
				</div>
			) : (
				<div className="modal-text-body">
					<div className="block-content">
						<p>
							An tâm tận hưởng hành trình vì chuyến đi của bạn trên Mioto đã được mua <b>Bảo hiểm thuê xe tự lái !</b>
						</p>
					</div>
					<div className="block-content">
						<p>
							❌ Hầu hết rủi ro phát sinh trong quá trình thuê xe tự lái, đặc biệt với những tổn thất lớn trong các sự
							vụ đâm đụng, thủy kích, cháy nổ (có thể lên đến hàng trăm triệu vượt khả năng chi trả) sẽ{" "}
							<u className="text-danger fontWeight-6">không thuộc phạm vi</u> của <b>Bảo hiểm thân vỏ xe theo năm</b>{" "}
							(hay còn gọi là Bảo hiểm 2 chiều). Vì vậy, Mioto khuyến nghị Quý khách hàng sử dụng gói{" "}
							<b>Bảo hiểm thuê xe tự lái</b> trên Mioto để phòng khi có sự cố xảy ra trong quá trình thuê xe.
						</p>
					</div>
					<div className="block-content">
						<p>
							•Gói Bảo hiểm thuê xe tự lái, với mức phí tiết kiệm & số tiền bảo hiểm lớn (đến 100% giá trị xe) sẽ giúp
							bạn không còn lo lắng khi thuê xe. Các phạm vi bảo hiểm chính:
						</p>
						<p>- Đâm va, cháy nổ, hỏa hoạn.</p>
						<p>- Thủy kích.</p>
						<p>- Hỗ trợ dịch vụ cứu hộ, cứu nạn.</p>
					</div>
					<div className="block-content">
						<p>
							Số tiền tối đa bạn chi trả cho các thiệt hại & tổn thất về xe là <b>2,000,000đ</b> (chưa gồm thiệt hại do
							xe không cho thuê được trong thời gian sửa chữa và các chế tài khác ngoài phạm vi bảo hiểm).
						</p>
					</div>
				</div>
			)}
		</Modal.Body>
	</Modal>
);

const PriceSummary = ({
	priceSummary,
	isSD,
	title,
	trip,
	car,
	promo,
	openPromoBox,
	removePromoCode,
	appInit,
	isOwner,
}) => {
	const priceMode = appInit?.data?.priceMode;
	const hiddenFeeMode = priceMode === 2;
	const discountWeekMonth =
		priceSummary?.priceOrigin * priceSummary?.totalDays +
		priceSummary?.deliveryFee -
		priceSummary?.commission -
		(priceSummary?.priceTotal - priceSummary?.deposit + priceSummary?.ownerPayable);
	const [showPSModal, setShowPSModal] = useState(false);
	const [showTFModal, setShowTFModal] = useState(false);
	const [showPSVOModal, setShowPSVOModal] = useState(false);
	const [showTFVOModal, setShowTFVOModal] = useState(false);
	const [showInsSDModal, setShowInsSDModal] = useState(false);

	return (
		<>
			<div className="price-container">
				{title && title !== "" ? trip ? <p className="title">{title}</p> : <h6>{title}</h6> : null}
				{isSD ? (
					<>
						<div className="price-item">
							<p className="df-align-center">
								Đơn giá thuê
								<span className="tooltip" onClick={() => setShowPSModal(true)}>
									<span className="wrap-svg">
										<Tooltip />
									</span>
								</span>
							</p>
							<p className="cost">
								<NumberFormat
									value={hiddenFeeMode ? priceSummary.priceOriginWithFee : priceSummary.priceOrigin}
									displayType={"text"}
									thousandSeparator={" "}
									decimalSeparator={","}
									suffix={"đ/ ngày"}
								/>
							</p>
						</div>
						{hiddenFeeMode ? null : (
							<>
								{priceSummary.tripFee > 0 && (
									<div className="price-item">
										<p className="df-align-center">
											Phí dịch vụ {isOwner && trip ? "- Khách thuê" : "Mioto"}
											<span className="tooltip" onClick={() => setShowTFModal(true)}>
												<span className="wrap-svg">
													<Tooltip />
												</span>
											</span>
										</p>
										<p className="cost">
											<NumberFormat
												value={priceSummary.tripFee}
												displayType={"text"}
												thousandSeparator={" "}
												decimalSeparator={","}
												suffix={"đ/ ngày"}
											/>
										</p>
									</div>
								)}
							</>
						)}
						{priceSummary.insuranceFee > 0 && (
							<div className="price-item">
								<p className="df-align-center">
									Bảo hiểm thuê xe
									<span className="tooltip" onClick={() => setShowInsSDModal(true)}>
										<span className="wrap-svg">
											<Tooltip />
										</span>
									</span>
								</p>
								<p className="cost">
									<NumberFormat
										value={priceSummary.insuranceFee}
										displayType={"text"}
										thousandSeparator={" "}
										decimalSeparator={","}
										suffix={"đ/ ngày"}
									/>
								</p>
							</div>
						)}
						<div className="line-page" />
						<div className="price-item">
							<p>Tổng cộng</p>
							<p className="cost">
								<NumberFormat
									value={
										hiddenFeeMode
											? priceSummary.priceOriginWithFee + priceSummary.insuranceFee
											: priceSummary.priceOrigin + priceSummary.insuranceFee
									}
									displayType={"text"}
									thousandSeparator={" "}
									decimalSeparator={","}
									suffix={"đ "}
								/>
								x&nbsp;{priceSummary.totalDays}&nbsp;ngày
							</p>
						</div>
						{priceSummary.deliveryFee >= 0 && priceSummary.deliveryDistance > 0 && (
							<div className="price-item">
								<TooltipP
									title={"Phí giao nhận xe"}
									desc={() => (
										<>
											Chủ xe có dịch vụ giao nhận xe tận nơi (2 chiều: nhận xe và trả xe). Phí được tính dựa trên khoảng
											cách từ bãi xe đến vị trí khách thuê đã lựa chọn trên ứng dụng.
										</>
									)}
								/>

								{priceSummary.deliveryFee > 0 ? (
									<p className="cost">
										<NumberFormat
											value={priceSummary.deliveryFee}
											displayType={"text"}
											thousandSeparator={" "}
											decimalSeparator={","}
											suffix={"đ"}
										/>
										&nbsp;
										{(priceSummary.deliveryDistance && priceSummary.deliveryDistance) > 0 && (
											<NumberFormat
												value={priceSummary.deliveryDistance}
												displayType={"text"}
												thousandSeparator={" "}
												decimalSeparator={","}
												prefix={" ("}
												suffix={" km)"}
												decimalScale={1}
											/>
										)}
									</p>
								) : (
									<p className="fontWeight-6">Miễn phí</p>
								)}
							</div>
						)}
						<Promotion
							priceSummary={priceSummary}
							isSD={true}
							promoCode={promo}
							openPromoBox={openPromoBox}
							removePromoCode={removePromoCode}
							priceMode={priceMode}
							car={car}
						/>
					</>
				) : (
					<>
						<div className="price-item">
							<TooltipP
								title={"Giá thuê"}
								desc={() => (
									<>
										Giá thuê đã bao gồm tiền tài xế, xăng xe, phí qua đêm, phục vụ chở khách tại điểm đến. Chưa bao gồm
										phí cầu đường, bến bãi...
									</>
								)}
							/>
							<p className="cost">
								<NumberFormat
									value={hiddenFeeMode ? priceSummary.specialPriceTotalWithFee : priceSummary.specialPriceTotal}
									displayType={"text"}
									thousandSeparator={" "}
									decimalSeparator={","}
									suffix={"đ"}
								/>
							</p>
						</div>
						{priceSummary.discountPercent > 0 && (
							<div className="price-item discount">
								<TooltipP
									title={"Giảm giá"}
									desc={() => (
										<>
											Chương trình giảm giá đặc biệt của chủ xe dành cho khách thuê. <br />
											Lưu ý: Giá ưu đãi trong chương trình giảm giá sẽ không được áp dụng đồng thời với mã khuyến mãi
										</>
									)}
								/>
								<p className="cost">
									<NumberFormat
										value={hiddenFeeMode ? priceSummary.totalPriceOriginWithFee : priceSummary.totalPriceOrigin}
										displayType={"text"}
										thousandSeparator={" "}
										decimalSeparator={","}
										suffix={"đ"}
									/>
								</p>
							</div>
						)}
						{priceSummary.specialDiscountTotal > 0 && (
							<div className="price-item discount">
								<TooltipP
									title={"Giảm giá"}
									desc={() => (
										<>
											Chương trình giảm giá đặc biệt của chủ xe dành cho khách thuê. <br />
											Lưu ý: Giá ưu đãi trong chương trình giảm giá sẽ không được áp dụng đồng thời với mã khuyến mãi
										</>
									)}
								/>
								<p className="cost">
									<NumberFormat
										value={hiddenFeeMode ? priceSummary.totalPriceOriginWithFee : priceSummary.totalPriceOrigin}
										displayType={"text"}
										thousandSeparator={" "}
										decimalSeparator={","}
										suffix={"đ"}
									/>
								</p>
							</div>
						)}
						{hiddenFeeMode ? null : (
							<>
								{priceSummary.tripFee > 0 && (
									<div className="price-item">
										<p className="df-align-center">
											Phí dịch vụ Mioto
											<span className="tooltip" onClick={() => setShowTFModal(true)}>
												<span className="wrap-svg">
													<Tooltip />
												</span>
											</span>
										</p>
										<p className="cost">
											<NumberFormat
												value={priceSummary.tripFee}
												displayType={"text"}
												thousandSeparator={" "}
												decimalSeparator={","}
												suffix={"đ"}
											/>
										</p>
									</div>
								)}
							</>
						)}
						{priceSummary.insuranceFee > 0 && (
							<div className="price-item">
								<TooltipP
									title={"Bảo hiểm thuê xe"}
									desc={() => (
										<>
											Chuyến đi của bạn được mua bảo hiểm Phúc&nbsp;Bình&nbsp;An <br />+ Bảo hiểm người ngồi trên xe:
											tối đa 200,000,000VND/người/vụ
											<br />+ Bảo hiểm TNDS về người &amp; tài sản cho bên thứ 3: tối đa 300,000,000VND/vụ
										</>
									)}
								/>
								<p className="cost">
									<NumberFormat
										value={priceSummary.insuranceFee}
										displayType={"text"}
										thousandSeparator={" "}
										decimalSeparator={","}
										suffix={"đ"}
									/>
								</p>
							</div>
						)}

						{priceSummary.deliveryFee >= 0 && priceSummary.deliveryDistance > 0 && (
							<div className="price-item">
								<TooltipP
									title={"Phí đưa đón"}
									desc={() => <>Phí được tính dựa trên khoảng cách giữa địa điểm đưa đón và vị trí xe</>}
								/>

								{priceSummary.deliveryFee > 0 ? (
									<p className="cost">
										<NumberFormat
											value={priceSummary.deliveryFee}
											displayType={"text"}
											thousandSeparator={" "}
											decimalSeparator={","}
											suffix={"đ "}
										/>
										&nbsp;
										{(priceSummary.deliveryDistance && priceSummary.deliveryDistance) > 0 && (
											<NumberFormat
												value={priceSummary.deliveryDistance}
												displayType={"text"}
												thousandSeparator={" "}
												decimalSeparator={","}
												prefix={" ("}
												suffix={" km)"}
												decimalScale={1}
											/>
										)}
									</p>
								) : (
									<p className="fontWeight-6">Miễn phí</p>
								)}
							</div>
						)}
						<Promotion
							priceSummary={priceSummary}
							isSD={false}
							promoCode={promo}
							openPromoBox={openPromoBox}
							removePromoCode={removePromoCode}
							priceMode={priceMode}
							car={car}
						/>
					</>
				)}

				<div className="line-page"></div>

				<div className={`price-item total`}>
					<p>Thành tiền</p>
					<p className="cost">
						<NumberFormat
							value={isSD ? priceSummary.priceTotal : priceSummary.finalPrice}
							displayType={"text"}
							thousandSeparator={" "}
							decimalSeparator={","}
							suffix={"đ"}
						/>
					</p>
				</div>

				{!car && (
					<>
						<div className="line-page" />
						<div className={`price-item deposit`}>
							<TooltipP
								title={"Đặt cọc qua ứng dụng"}
								desc={() => (
									<>
										- 30% giá trị chuyến đi cần được thanh toán trước qua Mioto để giữ chỗ xe thuê. Số tiền còn lại bạn
										sẽ thanh toán cho Chủ xe khi làm thủ tục nhận xe.
										<br />- Trường hợp bạn thay đổi ý định thuê xe, xin vui lòng hủy chuyến{" "}
										<b>
											<u>trong vòng 1h</u>
										</b>{" "}
										sau khi giữ chỗ để không bị mất phí.
									</>
								)}
							/>

							<p className="cost">
								<NumberFormat
									value={priceSummary.deposit}
									displayType={"text"}
									thousandSeparator={" "}
									decimalSeparator={","}
									suffix={"đ"}
								/>
							</p>
						</div>

						<div className={`price-item deposit`}>
							<TooltipP
								title={"Thanh toán khi nhận xe"}
								desc={() => (
									<>
										Bạn có thể thanh toán 70% giá trị thuê xe <b>Tiền mặt</b> hoặc <b>Chuyển khoản</b> cho Chủ xe khi
										làm thủ tục nhận&nbsp;xe.
									</>
								)}
							/>

							<p className="cost">
								<NumberFormat
									value={
										isSD
											? priceSummary.priceTotal - priceSummary.deposit
											: priceSummary.finalPrice - priceSummary.deposit
									}
									displayType={"text"}
									thousandSeparator={" "}
									decimalSeparator={","}
									suffix={"đ"}
								/>
							</p>
						</div>
					</>
				)}
			</div>
			{trip && isOwner && isSD && priceMode === 3 && (
				<>
					<div className="line-page" />
					<div className="price-container">
						<p className="title">Bảng tính thu nhập chủ xe</p>
						<div className="price-item">
							<p className="df-align-center">
								Đơn giá thuê
								<span className="tooltip" onClick={() => setShowPSVOModal(true)}>
									<span className="wrap-svg">
										<Tooltip />
									</span>
								</span>
							</p>
							<p className="cost">
								<NumberFormat
									value={priceSummary.priceOrigin}
									displayType={"text"}
									thousandSeparator={" "}
									decimalSeparator={","}
									suffix={"đ/ ngày"}
								/>
							</p>
						</div>
						<div className="price-item">
							<p className="df-align-center">Số ngày thuê</p>
							<p className="cost">{priceSummary.totalDays}&nbsp;ngày</p>
						</div>
						<div className="line-page" />
						<div className="price-item">
							<p className="df-align-center">Doanh thu cho thuê xe</p>
							<p className="cost">
								<NumberFormat
									value={priceSummary.priceOrigin * priceSummary.totalDays}
									displayType={"text"}
									thousandSeparator={" "}
									decimalSeparator={","}
									suffix={"đ"}
								/>
							</p>
						</div>
						{priceSummary.deliveryFee > 0 && (
							<div className="price-item">
								<p className="df-align-center">Doanh thu giao nhận xe</p>
								<p className="cost">
									<NumberFormat
										value={priceSummary.deliveryFee}
										displayType={"text"}
										thousandSeparator={" "}
										decimalSeparator={","}
										suffix={"đ"}
									/>
								</p>
							</div>
						)}
						{priceSummary.commission > 0 && (
							<div className="price-item">
								<p className="df-align-center">
									Phí dịch vụ - Chủ xe
									<span className="tooltip" onClick={() => setShowTFVOModal(true)}>
										<span className="wrap-svg">
											<Tooltip />
										</span>
									</span>
								</p>
								<p className="cost">
									-
									<NumberFormat
										value={priceSummary.commission}
										displayType={"text"}
										thousandSeparator={" "}
										decimalSeparator={","}
										suffix={"đ"}
									/>
								</p>
							</div>
						)}
						{discountWeekMonth > 0 && (
							<div className="price-item">
								<p className="df-align-center">Giảm giá thuê tuần/tháng</p>
								<p className="cost">
									-
									<NumberFormat
										value={discountWeekMonth}
										displayType={"text"}
										thousandSeparator={" "}
										decimalSeparator={","}
										suffix={"đ"}
									/>
								</p>
							</div>
						)}
						<div className="line-page" />
						{priceSummary.deliveryFee >= 0 && priceSummary.commission >= 0 && (
							<div className="price-item">
								<p className="df-align-center">Thu nhập chủ xe (a)</p>
								<p className="cost">
									<NumberFormat
										value={priceSummary.priceTotal - priceSummary.deposit + priceSummary.ownerPayable}
										displayType={"text"}
										thousandSeparator={" "}
										decimalSeparator={","}
										suffix={"đ"}
									/>
								</p>
							</div>
						)}
						<div className="price-item">
							<p className="df-align-center">Khách thanh toán cho chủ xe (b)</p>
							<p className="cost">
								<NumberFormat
									value={priceSummary.priceTotal - priceSummary.deposit}
									displayType={"text"}
									thousandSeparator={" "}
									decimalSeparator={","}
									suffix={"đ"}
								/>
							</p>
						</div>
						{priceSummary.ownerPayable > 0 && (
							<div className="price-item deposit">
								<p className="df-align-center">Số tiền cộng ví chủ xe (a-b)</p>
								<p className="cost">
									<NumberFormat
										value={priceSummary.ownerPayable}
										displayType={"text"}
										thousandSeparator={" "}
										decimalSeparator={","}
										suffix={"đ"}
									/>
								</p>
							</div>
						)}
					</div>
				</>
			)}

			<PriceSpecialModal show={showPSModal} onHide={() => setShowPSModal(false)} priceMode={priceMode} />
			<TripFeeModal show={showTFModal} onHide={() => setShowTFModal(false)} isOwner={isOwner} trip={trip} isSD={isSD} />
			<PriceSpecialViewOwnerModal show={showPSVOModal} onHide={() => setShowPSVOModal(false)} />
			<TripFeeViewOwnerModal show={showTFVOModal} onHide={() => setShowTFVOModal(false)} />
			<InsSDModal show={showInsSDModal} onHide={() => setShowInsSDModal(false)} trip={trip} isOwner={isOwner} />
		</>
	);
};

function mapState(state) {
	return {
		appInit: state.appInit,
	};
}

export default connect(mapState)(PriceSummary);
